<script lang="ts">
  import IconifyIcon from '@iconify/svelte'
  import arrowLeft from '@iconify/icons-fa-solid/arrow-left'
  import MainLayout from "../#common/layout/Layout.svelte"
  import DepositWithdraw from "./components/wallet/DepositWithdraw.svelte";
  import Marketplace from "./components/wallet/Marketplace.svelte";
  import { Link } from 'svelte-routing';

  let selectedTab = 'marketplace';
</script>

<svelte:head>
  <title>Wallet Analytics</title>
</svelte:head>

<MainLayout title="Wallet Analytics">
  <svelte:fragment slot="content">
      <Link to="/analytics" class="analytics-back-link">
          <IconifyIcon icon={arrowLeft}/><span> Back</span>
      </Link>
      <div class="card">
          <div class="card-body">
              <ul class="nav nav-tabs nav-bordered mb-3">
                  <li class="nav-item">
                      <div class="nav-link" class:active={selectedTab === 'marketplace'} on:click={()=>selectedTab = 'marketplace'}>
                          <span>NFT Marketplace</span>
                      </div>
                  </li>
                  <li class="nav-item">
                      <div class="nav-link" class:active={selectedTab === 'depositWithdraw'} on:click={()=>selectedTab = 'depositWithdraw'}>
                          <span>Deposit/Withdraw</span>
                      </div>
                  </li>
              </ul>
              <div class="tab-content">
                  <div class="tab-pane active analytics-pane">
                      {#if selectedTab === 'marketplace'}
                          <Marketplace/>
                      {:else if selectedTab === 'depositWithdraw'}
                          <DepositWithdraw/>
                      {/if}
                  </div>
              </div>
          </div>
      </div>
  </svelte:fragment>
</MainLayout>

<style>
  .nav-tabs .nav-link {
      user-select: none;
      cursor: pointer;
  }

  .nav-tabs .nav-link.active {
      color: white;
      background-color: #FF5D1C;
      border-color: transparent transparent #FF5D1C;
      cursor: default;
  }

  :global(.analytics-back-link) {
    width: 60px;
    display: flex;
    align-items: center;
    color: #000;
    margin-bottom: 30px;
  }

  :global(.analytics-back-link span) {
    margin-left: 10px;
  }

  :global(.analytics-back-link:hover) {
    color: #FF5D1C;
  }
</style>
